import { QueryClient } from '@tanstack/react-query'

/**
 * QueryClient unico do app. Mora fora do `App.tsx` para o logout limpar o cache
 * (`clearSessionData`) sem depender de componente montado.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})
